import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

import { State } from './language.state';

export const selectLanguageTokens = createFeatureSelector<State>('Language');

export const selectToken = (token: string): MemoizedSelector<object, string> => createSelector(selectLanguageTokens, (tokens: State) => tokens[token]);